import type { VisualElement } from "./VisualElement"

export const visualElementStore = new WeakMap<any, VisualElement>()
